// Heading line is "#### Title" or "#### Title [[ctx:1]]..."
function isPointHeading(line: string, title: string): boolean {
  const heading = `#### ${title}`;
  return line === heading || line.startsWith(`${heading} [[ctx:`);
}

export default function addPointRagIcons(
  text: string,
  pointRagStates?: Record<string, string>,
): string {
  if (!pointRagStates) {
    return text;
  }
  const titles = Object.keys(pointRagStates);
  if (titles.length === 0) {
    return text;
  }
  // Point heading comes first; a later repeat is the LLM's own heading
  const marked = new Set<string>();
  return text
    .split("\n")
    .map(line => {
      const title = titles.find(
        item => !marked.has(item) && isPointHeading(line, item),
      );
      if (title === undefined) {
        return line;
      }
      marked.add(title);
      const state = encodeURIComponent(pointRagStates[title]);
      return `${line} <RagIcon state="${state}"></RagIcon>`;
    })
    .join("\n");
}
